import ShopItemsView from "../../components/shopItemsView/shopItemsView";

const ManufacturerOwnerView = () => {
    return (
        <div>
            <ShopItemsView update="/manufacturer-item-update" urlone="/manufacturer-owner-profile" deleteurl="/manufacturer-owner-profile" />
        </div>
    )
}
export default ManufacturerOwnerView;